import { Scenarios } from '@jfs/network'

const getVoucher = {
  default: [
    {
      url: /getVoucher/,
      method: 'POST',
      body: /remitterId/,
      response: {
        voucherDetails: [
          {
            voucherId: '1012225301491599000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'REDEEM_IN_PROGRESS',
            agentId: '101',
            originalTranId: '1000',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneName: 'Test User' },
          },
          {
            voucherId: '1012226360088336000',
            voucherAmount: 0.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '0',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'X',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'X' },
          },
          {
            voucherId: '1012226360130858000',
            voucherAmount: 0.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '0',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'X',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'X' },
          },
          {
            voucherId: '1012226360319840000',
            voucherAmount: 0.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '10',
            originalTranId: '0',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'X',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'X' },
          },
          {
            voucherId: '1012226365004148000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '222222',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226436564475000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227049438657000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '917912311139',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227049492309000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '917912311149',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227052534340000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'REDEEM_IN_PROGRESS',
            agentId: '1000000001',
            originalTranId: '917912511199',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX8245',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX8245' },
          },
          {
            voucherId: '1012225668255894000',
            voucherAmount: 33.0,
            transactionDate: 1662632307000,
            voucherStatus: 'ACTIVE',
            agentId: 'abhaykumar',
            originalTranId: '10012225156907251000',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX3563505500',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX3563505500' },
          },
          {
            voucherId: '1012225481781221000',
            voucherAmount: 33.0,
            transactionDate: 1662632307000,
            voucherStatus: 'ACTIVE',
            agentId: 'abhaykumar',
            originalTranId: '11012225156907251000',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX3563505500',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX3563505500' },
          },
          {
            voucherId: '1012225749279632000',
            voucherAmount: 33.0,
            transactionDate: 1662632307000,
            voucherStatus: 'ACTIVE',
            agentId: 'abhaykumar',
            originalTranId: '10012225156907251000',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX3563505500',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX3563505500' },
          },
          {
            voucherId: '1012226356549701000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '89',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'X',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'X' },
          },
          {
            voucherId: '1012226356613724000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '0',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'X',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'X' },
          },
          {
            voucherId: '1012226984666029000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '917912311111',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227002236767000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '917912311115',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227003083788000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '917912311117',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227036096982000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '917912311119',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227149532969000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '91291231111',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227149576337000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '91291231112',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227149664817000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '91291231113',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227151467404000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '91291231115',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227152236362000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '91291231116',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225540268636000',
            voucherAmount: 33.0,
            transactionDate: 1662632307000,
            voucherStatus: 'ACTIVE',
            agentId: 'abhaykumar',
            originalTranId: '10112225156907251000',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX3563505500',
              mobileNumber: { countryCode: '91', number: 9718295765 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX3563505500' },
          },
          {
            voucherId: '1012225557708455000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225564195978000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'REDEEM_IN_PROGRESS',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225564492945000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'REDEEM_IN_PROGRESS',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225738119753000',
            voucherAmount: 33.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: 'abhaykumar',
            originalTranId: '10012225156907251000',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX3563505500',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX3563505500' },
          },
          {
            voucherId: '1012225739381950000',
            voucherAmount: 33.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: 'abhaykumar',
            originalTranId: '10012225156907251000',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX3563505500',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX3563505500' },
          },
          {
            voucherId: '1012225739662114000',
            voucherAmount: 33.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: 'abhaykumar',
            originalTranId: '10012225156907251000',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX3563505500',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX3563505500' },
          },
          {
            voucherId: '1012225740257981000',
            voucherAmount: 33.0,
            transactionDate: 1662632307000,
            voucherStatus: 'ACTIVE',
            agentId: 'abhaykumar',
            originalTranId: '10012225156907251000',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX3563505500',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX3563505500' },
          },
          {
            voucherId: '1012225959695711000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225960663824000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225960685439000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226545052924000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '22323323',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227035197593000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '917912311118',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227239301489000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '91291231239',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX8245',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX8245' },
          },
          {
            voucherId: '1012225536776703000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225537189434000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225537352900000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225560665788000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225669299252000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225742178773000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225959745953000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226336110487000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226336941452000',
            voucherAmount: 50.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226337017836000',
            voucherAmount: 50.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: ' ',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226337142625000',
            voucherAmount: 50.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: ' ',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226337160273000',
            voucherAmount: 50.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '23452345',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226337178596000',
            voucherAmount: 50.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '23452345',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226337201142000',
            voucherAmount: 50.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '23452345',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226337230458000',
            voucherAmount: 50.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '23452345',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226346669286000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226359813243000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '0',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'X',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'X' },
          },
          {
            voucherId: '1012227049752240000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '917912311159',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227049832124000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '917912311169',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227050332994000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'REDEEM_IN_PROGRESS',
            agentId: '1000000001',
            originalTranId: '917912311199',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX8245',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX8245' },
          },
          {
            voucherId: '1012227050714158000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'REDEEM_IN_PROGRESS',
            agentId: '1000000001',
            originalTranId: '917912411199',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX8245',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX8245' },
          },
          {
            voucherId: '1012227051336217000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'REDEEM_IN_PROGRESS',
            agentId: '1000000001',
            originalTranId: '91791230',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227150727360000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '91291231114',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227154727318000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '91291231117',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227236573097000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'REDEEM_IN_PROGRESS',
            agentId: '1000000001',
            originalTranId: '91291231219',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX8245',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX8245' },
          },
          {
            voucherId: '1012225538254165000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225559903455000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225563326282000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'REDEEM_IN_PROGRESS',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012225570662667000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226347908681000',
            voucherAmount: 102.0,
            transactionDate: 1662575400000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226369928602000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '2444222',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226544665428000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '22323322',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012226947897303000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '101',
            originalTranId: '8979',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227049898852000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '917912311179',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXX7890',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXX7890' },
          },
          {
            voucherId: '1012227049946455000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '917912311189',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX8245',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX8245' },
          },
          {
            voucherId: '1012227054904463000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'ACTIVE',
            agentId: '1000000001',
            originalTranId: '917912611199',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX9245',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX9245' },
          },
          {
            voucherId: '1012227169776722000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'REDEEM_IN_PROGRESS',
            agentId: '1000000001',
            originalTranId: '91291231118',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX8245',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX8245' },
          },
          {
            voucherId: '1012227173890815000',
            voucherAmount: 102.0,
            transactionDate: 1575936000000,
            voucherStatus: 'REDEEM_IN_PROGRESS',
            agentId: '1000000001',
            originalTranId: '91291231119',
            remittanceDetails: {
              remitterId: '1662358270850013081',
              remitterFirstName: 'First',
              remitterMiddleName: 'Middle',
              remitterLastName: 'Last',
              remitterAccountNumber: 'XXXXXXXXXX8245',
              mobileNumber: { countryCode: '91', number: 7208662914 },
            },
            beneficiaryDetails: { beneAccNum: 'XXXXXXXXXX8245' },
          },
        ],
      },
      delay: 500,
    },
    {
      url: /getVoucher/,
      method: 'POST',
      response: {
        voucherId: '1012227755764269000',
        voucherCode: null,
        voucherReferenceNumber: '767543842820',
        voucherGeneratedDate: null,
        transactionDate: 1664876184000,
        voucherAmount: 1.0,
        originalTranId: '10672227676624866000',
        originalRRN: null,
        utr: '767543842820',
        transactionFailedReason: null,
        voucherStatus: 'ACTIVE',
        voucherValidUntil: null,
        remittanceDetails: {
          remitterId: '1492410456793179238',
          remitterFirstName: 'omkar',
          remitterMiddleName: null,
          remitterLastName: 'shinde',
          remitterAccountNumber: 'XXXXX6041',
          mobileNumber: { countryCode: '91', number: 8689906641 },
        },
        transactionAgentDetails: {
          agentId: 'sit-agent-2',
          agentName: null,
          agentUserId: null,
          agentStateCode: null,
          agentPinCode: null,
          agentLatitude: null,
          agentLongitude: null,
        },
        redeemAgentDetails: null,
        beneficiaryDetails: {
          beneId: null,
          beneAccNum: 'XXXXX6041',
          beneName: null,
          beneIFSC: null,
          beneBankName: null,
          beneBranchName: null,
        },
      },

      delay: 500,
    },
  ],
  failed: [
    {
      url: /getVoucher/,
      method: 'POST',
      responseCode: 5000,
      response: { status: 'FAILURE', error: { code: '33607', message: 'Session does not exists.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { getVoucher }
